$(document).ready(function () {
    $('#table-billboard').DataTable({
        lengthChange: false,
        pageLength: 5,
        columnDefs: [
            {
                targets: [1], // Índice de la columna que deseas ocultar
                visible: false
            }
        ],
        order: [[1, 'asc']],
        language: {
            search: "Buscar participante:",
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
    });
})
